var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "128",
      "height": "91"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "M11.426 76c.512 0 .766-.115 1.184-.534l8.203-10.717c.71-.713.71-1.67 0-2.384-.7-.705-1.675-.702-2.374 0l-5.298 7.794V16.87c0-3.14 2.265-5.419 5.386-5.419h53.26c1.12 0 1.713-.597 1.713-1.725S72.907 8 71.787 8h-53.26c-5.026 0-8.815 3.813-8.815 8.87v53.284l-5.304-7.788c-.35-.352-.77-.528-1.19-.528-.418 0-.837.176-1.186.527-.71.713-.71 1.67 0 2.384l8.203 10.717c.412.414.679.534 1.191.534"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "1.5",
      "d": "M11.426 76c.512 0 .766-.115 1.184-.534l8.203-10.717c.71-.713.71-1.67 0-2.384-.7-.705-1.675-.702-2.374 0l-5.298 7.794V16.87c0-3.14 2.265-5.419 5.386-5.419h53.26c1.12 0 1.713-.597 1.713-1.725S72.907 8 71.787 8h-53.26c-5.026 0-8.815 3.813-8.815 8.87v53.284l-5.304-7.788c-.35-.352-.77-.528-1.19-.528-.418 0-.837.176-1.186.527-.71.713-.71 1.67 0 2.384l8.203 10.717c.412.414.679.534 1.191.534z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFE86C",
      "d": "M109.783 58c-1.122 0-1.717.596-1.717 1.723v21.415c0 3.137-2.27 5.414-5.395 5.414H10.216c-1.123 0-1.716.598-1.716 1.725S9.093 90 10.216 90h92.455c5.034 0 8.829-3.81 8.829-8.862V59.723c0-1.127-.594-1.723-1.717-1.723"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "1.5",
      "d": "M109.783 58c-1.122 0-1.717.596-1.717 1.723v21.415c0 3.137-2.27 5.414-5.395 5.414H10.216c-1.123 0-1.716.598-1.716 1.725S9.093 90 10.216 90h92.455c5.034 0 8.829-3.81 8.829-8.862V59.723c0-1.127-.594-1.723-1.717-1.723z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M101.463 4.226c-5.544 0-11.077 2.358-15.18 6.47-4.232 3.883-6.562 9.318-6.562 15.303 0 5.99 2.293 11.387 6.456 15.198 3.878 4.24 9.307 6.575 15.286 6.575 5.974 0 11.372-2.307 15.201-6.495 4.216-4.045 6.537-9.472 6.537-15.28s-2.294-11.203-6.458-15.194c-3.885-4.242-9.31-6.577-15.28-6.577m0 46.774c-6.95 0-13.093-2.47-17.762-7.141C78.99 38.826 76.5 32.65 76.5 25.999c0-6.647 2.463-12.795 7.123-17.78C88.653 3.496 94.82 1 101.463 1c6.634 0 12.78 2.477 17.773 7.162 4.676 4.834 7.256 11.167 7.264 17.83.008 6.658-2.55 12.975-7.203 17.788C114.19 48.57 108.19 51 101.463 51"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "1.5",
      "d": "M101.463 4.226c-5.544 0-11.077 2.358-15.18 6.47-4.232 3.883-6.562 9.318-6.562 15.303 0 5.99 2.293 11.387 6.456 15.198 3.878 4.24 9.307 6.575 15.286 6.575 5.974 0 11.372-2.307 15.201-6.495 4.216-4.045 6.537-9.472 6.537-15.28s-2.294-11.203-6.458-15.194c-3.885-4.242-9.31-6.577-15.28-6.577zm0 46.774c-6.95 0-13.093-2.47-17.762-7.141C78.99 38.826 76.5 32.65 76.5 25.999c0-6.647 2.463-12.795 7.123-17.78C88.653 3.496 94.82 1 101.463 1c6.634 0 12.78 2.477 17.773 7.162 4.676 4.834 7.256 11.167 7.264 17.83.008 6.658-2.55 12.975-7.203 17.788C114.19 48.57 108.19 51 101.463 51z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "m103.198 26.5 5.813-5.811c.334-.334.519-.848.485-1.341-.022-.316-.137-.579-.303-.705l-.182-.157c-.645-.645-1.553-.65-2.203.001l-5.801 5.813-5.815-5.814c-.629-.628-1.564-.637-2.202 0-.647.648-.647 1.554 0 2.203l5.812 5.812-5.812 5.812c-.32.32-.49.7-.49 1.1 0 .402.17.782.49 1.102.312.313.848.485 1.099.485.222 0 .78-.161 1.103-.485l5.815-5.813 5.803 5.814c.311.31.852.484 1.104.484.25 0 .785-.172 1.097-.485.647-.648.647-1.553 0-2.202l-5.813-5.812z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "1.5",
      "d": "m103.198 26.5 5.813-5.811c.334-.334.519-.848.485-1.341-.022-.316-.137-.579-.303-.705l-.182-.157c-.645-.645-1.553-.65-2.203.001l-5.801 5.813-5.815-5.814c-.629-.628-1.564-.637-2.202 0-.647.648-.647 1.554 0 2.203l5.812 5.812-5.812 5.812c-.32.32-.49.7-.49 1.1 0 .402.17.782.49 1.102.312.313.848.485 1.099.485.222 0 .78-.161 1.103-.485l5.815-5.813 5.803 5.814c.311.31.852.484 1.104.484.25 0 .785-.172 1.097-.485.647-.648.647-1.553 0-2.202l-5.813-5.812z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }